module.exports = __webpack_public_path__ + "static/media/reportBadgeLevel3Locked.078f3d7f.png";